import { render, staticRenderFns } from "./TypeBuildingMaterialForm.vue?vue&type=template&id=6adcf04e&"
import script from "./TypeBuildingMaterialForm.vue?vue&type=script&lang=js&"
export * from "./TypeBuildingMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports